import { getStore } from '../store/store';

export function isLoading() {
    return getStore().isLoading;
}
